// 首页API
import api from './http'

// 获取全部机场城市数据
export function getAirCityData () {
  return api.post('/baseData/getAirportEasy', {isSign: 'ALL'}, {
    headers: {
      load: false
    }
  }
  )
}
// 获取机场城市数据
export function getAirport (params) {
  return api.post('/baseData/getAirport', params, {
    headers: {
      load: false
    }
  }
  )
}
// 获取数据字典
export function getDict () {
  return api.post('/baseData/getDict', {}, {
    headers: {
      load: false
    }
  }
  )
}
// 获取参数管理
export function getParam (params) {
  return api.post('/baseData/getParam', params, {
    headers: {
      load: false
    }
  })
}
// 获取航司数据
export function getAirCodeData () {
  return api.post(
    '/baseData/getAirCodeData',
    {
      isSign: 'ALL'
    },
    {
      headers: {
        load: false
      }
    }
  )
}
// 获取国籍
export function getCountry (params) {
  return api.post('/baseData/getCountry', params, {
    headers: {
      load: false
    }
  })
}
// 获取当前用户的常客（包括部门员工）
export function getServicePassengersPage (params) {
  return api.post('/passengerRegular/selectServicePassengersPage', params, {
    headers: {
      load: false
    }
  })
}
// 获取当前用户的临客
export function getTemporaryPassengersPage (params) {
  return api.post('/passengerRegular/selectTemporaryPassengersPage', params, {
    headers: {
      load: false
    }
  })
}
// 获取部门树
export function getDeptOrgTree (params, load) {
  return api.post('/sm/dept/deptOrgTree', params, {
    headers: {
      customerNo: params.customerNo,
      load: !load
    }
  })
}
export function queryDeptOrgTree (params, load) {
  return api.post('/sm/dept/queryDeptOrgTree', params, {
    headers: {
      customerNo: params.customerNo,
      load: !load
    }
  })
}
// 获取成本中心数据
export function getCostcenterInfo (params) {
  return api.post('/passengerRegular/selectCostcenterInfo', params)
}

// 获取常客 成本中心信息
export function checkTravelPassengers (params) {
  return api.post('/passengerRegular/checkTravelPassengers', params)
}

// 获取企业帐户查询
export function accountSelect (params, load) {
  return api.post('/cps/account/select', params, {
    headers: {
      load: !!load
    }
  })
}

// 公告查询
export function getNotifylist (params) {
  return api.post('/baseData/getNotifyList', params, {
    headers: {
      load: false
    }
  })
}

// 公告内容解析
export function queryNotifyContent (params) {
  return api.post('/notice/queryNotifyContent', params, {
    headers: {
      load: false
    }
  })
}
// 历史查询数据获取
export function selectSearchRecord (params) {
  return api.post('/baseData/selectSearchRecord', params, {
    headers: {
      load: false
    }
  })
}
// 清空操作记录查询
export function delSearchRecord (params) {
  return api.post('/baseData/delSearchRecord', params)
}

// 当前登录用户查询常旅客
export function selectFrequentFlyerPgs (params) {
  return api.post('/passengerRegular/selectFrequentFlyerPgs', params)
}
// 根据id查询员工信息
export function getPassengerById (params) {
  return api.post('/passengerRegular/getPassengerById', params)
}
// 获取出行通知信息
export function queryInform (params) {
  return api.post('/travelProductInform/queryInform', params)
}



// WEBPACK FOOTER //
// ./src/axios/indexApi.js